import axiosInstance from '@/utils/api.js'

var state = {
  telephonyServiceLink: []
}

var getters = {
  TELEPHONY_SERVICE_LINK: (state) => {
    return state.telephonyServiceLink
  }
}

var mutations = {
  SET_TELEPHONY_SERVICE_LINK: (state, payload) => {
    state.telephonyServiceLink = payload || []
  }
}

var actions = {
  GET_TELEPHONY_SERVICE_LINK: async (context, payload) => {
    let result = await axiosInstance.get('/users/servicelinks/telephony?slink_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_TELEPHONY_SERVICE_LINK', result.data)
    }
  },
  CREATE_TELEPHONY_SERVICE_LINK: (context, payload) => {
    return axiosInstance.post('/users/servicelinks/telephony', payload)
  },
  UPDATE_TELEPHONY_SERVICE_LINK: (context, payload) => {
    return axiosInstance.put('/users/servicelinks/telephony', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/servicesLinkTelephony.js